var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('side-menu'),_c('nave-bar'),_c('bread-crumb'),_c('router-view'),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }